import '../../PracticeOverview.css';
import classNames from 'classnames';
import { Col, Row } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRandom, faUsers } from '@fortawesome/free-solid-svg-icons';
import { actions } from '../../../../../context';
import hasPermission from '../../../../Shared/hasPermission';

const PracticeOfferings = () => {
    const dispatch = useDispatch();

    const practiceId = useSelector((state) => state.practice.practice?.id);

    const practiceOfferings = useSelector(
        (state) => state.practice.practice?.practiceOfferings,
        practiceOfferingsEqualityCheck
    );

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canManageOfferings = hasPermission(`ManageOfferings`, permissions);

    const openRelationsModal = () => {
        // make sure this is working with this modal
        dispatch(actions.relations.fetchRelations(practiceId));
        dispatch(actions.offerings.fetchAllOfferings());
        dispatch(
            actions.practice.setPracticeRelationsModalWorkingPractice({
                id: practiceId,
            })
        );
        dispatch(actions.toggle.toggleRelationsModalOpen(true));
    };

    const offeringProps = {
        md: 12,
        className: 'hover-parent d-flex px-3 py-2',
        title: 'Active Offerings',
    };
    const childProps = {};

    if (canManageOfferings) {
        offeringProps.className += ' hoverable';
        offeringProps.onClick = openRelationsModal;
        childProps.className = 'hoverable config-item';
    }

    return (
        <Col {...offeringProps}>
            <FontAwesomeIcon
                className="text-light op-6"
                icon={faUsers}
                size="lg"
            />
            &emsp;
            {practiceOfferings?.length > 0 ? (
                <div {...childProps}>
                    {practiceOfferings?.map((o, x) => (
                        <Row
                            key={o.id}
                            className={classNames({
                                'pt-1': x > 0,
                                'pb-1': x < practiceOfferings.length - 1,
                            })}>
                            <Col xs="12">
                                <div>
                                    {canManageOfferings && (
                                        <span className="text-nowrap">
                                            {o.partner}&emsp;-&emsp;
                                        </span>
                                    )}
                                    <span className="text-nowrap">
                                        {o.name}
                                        {o.isConversionOffering && (
                                            <>
                                                &emsp;
                                                <FontAwesomeIcon
                                                    className="text-light op-6"
                                                    icon={faRandom}
                                                />
                                            </>
                                        )}
                                    </span>
                                    {o.partnerCustomId &&
                                        o.partnerCustomId.length > 0 && (
                                            <span>
                                                <br />
                                                Partner ID: {o.partnerCustomId}
                                            </span>
                                        )}
                                </div>
                            </Col>
                        </Row>
                    ))}
                </div>
            ) : (
                <span>No Active Offerings</span>
            )}
        </Col>
    );
};
const practiceOfferingsEqualityCheck = (newList, oldList) => {
    if (oldList.length !== newList.length) return false;
    if(oldList.length === 0 && newList.length === 0) return true;
    const listEqualityCheck = (oldElement) => {
        const template = {
            id: '',
            name: '',
            partner: '',
            isConversionOffering: false,
            partnerCustomId: null,
        };
        const oldState = Object.assign(
            {},
            template,
            ...Object.keys(template).map(
                (k) => k in oldElement && { [k]: oldElement[k] }
            )
        );

        const compareElements = (newElement) => {
            const newState = Object.assign(
                {},
                template,
                ...Object.keys(template).map(
                    (k) => k in newElement && { [k]: newElement[k] }
                )
            );
            return shallowEqual(oldState, newState);
        };
        const check = newList.find(compareElements);
        return check !== undefined;
    };
    const comparedList = !!oldList.length && oldList.every(listEqualityCheck);

    const isSameList = !!newList.length && comparedList;
    return isSameList;
};

export default PracticeOfferings;
